
import { importSync as i } from '@embroider/macros';
let d = window.define;
import "@ember/string/-embroider-implicit-modules.js";
